// Copyright (C) 2024 Skylark Drones

import cameraLensWide from '@/assets/images/camera_lens_wide.svg'
import skylarkCameraLensWide from '@/assets/images/skylark_camera_lens_wide.svg'
import disabledCameraLensWide from '@/assets/images/disabled_camera_lens_wide.svg'
import cameraLensThermal from '@/assets/images/camera_lens_thermal.svg'
import skylarkCameraLensThermal from '@/assets/images/skylark_camera_lens_thermal.svg'
import disabledCameraLensThermal from '@/assets/images/disabled_camera_lens_thermal.svg'
import cameraLensZoom from '@/assets/images/camera_lens_zoom.svg'
import skylarkCameraLensZoom from '@/assets/images/skylark_camera_lens_zoom.svg'
import disabledCameraLensZoom from '@/assets/images/disabled_camera_lens_zoom.svg'
import lensWide from '@/assets/images/lens_wide.svg'
import lensIR from '@/assets/images/lens_ir.svg'

export const CAMERA_CONTROL_TYPES = {
  GET_DRONE_CAMERA_STATE: 'get_drone_camera_state',
  SET_DRONE_CAMERA_MODE: 'set_drone_camera_mode',
  TOGGLE_VIDEO_RECORD: 'toggle_video_record',
  CAPTURE_PHOTO: 'capture_photo',
  SET_GIMBAL_PITCH: 'set_gimbal_pitch',
  SET_LENS_TYPE: 'set_lens_type'
}

export const CAMERA_MODES = {
  PHOTO: 'photo',
  VIDEO: 'video'
}

export const CAMERA_LENS = {
  WIDE: 'wide',
  THERMAL: 'ir',
  ZOOM: 'zoom'
}

export const CAMERA_LENS_ICON_INFO = {
  [CAMERA_LENS.WIDE]: {
    default: cameraLensWide,
    active: skylarkCameraLensWide,
    disabled: disabledCameraLensWide
  },
  [CAMERA_LENS.THERMAL]: {
    default: cameraLensThermal,
    active: skylarkCameraLensThermal,
    disabled: disabledCameraLensThermal
  },
  [CAMERA_LENS.ZOOM]: {
    default: cameraLensZoom,
    active: skylarkCameraLensZoom,
    disabled: disabledCameraLensZoom
  },
  normal: {
    default: cameraLensWide,
    active: skylarkCameraLensWide,
    disabled: disabledCameraLensWide
  }
}

export const CAMERA_LENS_MAPPER = {
  [CAMERA_LENS.WIDE]: {
    icon: lensWide,
    label: 'Wide'
  },
  [CAMERA_LENS.THERMAL]: {
    icon: lensIR,
    label: 'IR'
  }
}

// TODO: Make the error messages more dynamic using error_type
const ERROR_MSG_MAP = {
  [CAMERA_CONTROL_TYPES.SET_DRONE_CAMERA_MODE]: getCameraModeErrorMsg,
  [CAMERA_CONTROL_TYPES.TOGGLE_VIDEO_RECORD]: getVideoRecordingErrorMsg,
  [CAMERA_CONTROL_TYPES.CAPTURE_PHOTO]: getPhotoCaptureErrorMsg,
  [CAMERA_CONTROL_TYPES.SET_GIMBAL_PITCH]: getGimbalPitchErrorMsg,
  [CAMERA_CONTROL_TYPES.SET_LENS_TYPE]: getLensTypeErrorMsg
}

export function getCameraErrorMessage(error) {
  return (
    ERROR_MSG_MAP[error.command_type]?.(error.value) ||
    'Unable to perform action'
  )
}

function getCameraModeErrorMsg(value) {
  return `Unable to switch to ${value} mode`
}

function getVideoRecordingErrorMsg(value) {
  const action = value ? 'start' : 'stop'
  return `Unable to ${action} video recording`
}

function getPhotoCaptureErrorMsg(value) {
  return 'Unable to capture photo'
}

function getGimbalPitchErrorMsg(value) {
  return `Unable to set gimbal pitch to ${value}°`
}

function getLensTypeErrorMsg(value) {
  let lens
  switch (value) {
    case CAMERA_LENS.WIDE:
      lens = 'Wide'
      break
    case CAMERA_LENS.ZOOM:
      lens = 'Zoom'
      break
    case CAMERA_LENS.THERMAL:
      lens = 'IR'
      break
  }
  return `Unable to switch to ${lens} lens`
}
